import { useCallback } from 'react';
import { css } from '@emotion/react';
import { QuickActionsNavMode } from '@frontend/quick-actions';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { AllAppsModule } from '../../../../components/dashboard/all-apps-module';
import { useNav } from '../providers/nav-provider';
import { useNavModeStore } from '../stores/store';
import { NavTabs } from './nav-tabs';

type BubbleNavContentProps = {
  children: React.ReactNode;
};

export const BubbleNavContent = ({ children }: BubbleNavContentProps) => {
  const { navMode } = useNavModeStore(['navMode']);
  const setOpen = useNav((state) => state.setOpen);

  return (
    <>
      <Button
        css={css({
          position: 'absolute',
          right: theme.spacing(1.25),
          top: theme.spacing(6.25),
          zIndex: theme.zIndex.middle,
        })}
        onClick={() => setOpen(false)}
        iconName='x'
        size='large'
        variant='secondary'
      />
      <NavTabs />
      {navMode === 'all-apps' && (
        <div
          css={css({
            flex: 1,
            overflow: 'auto',
            padding: theme.spacing(3),
            paddingTop: theme.spacing(0.5),
          })}
        >
          {children}
        </div>
      )}
    </>
  );
};

export const BubbleNav = () => {
  const setOpen = useNav((state) => state.setOpen);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <BubbleNavContent>
      <AllAppsModule handleModalClose={handleClose} showHeader={false} />
      <QuickActionsNavMode onClick={handleClose} />
    </BubbleNavContent>
  );
};
